/* Copy of @mkskom/utils/useLoading with reactivity (added 3 & updated 3 lines) */
import { ref } from 'vue';

const isLoading = ref(false); // added 1

/**
 * fetch current loading state
 */

const varName = 'isGlobalLoading1';

function fetchGlobalLoadingState() {
  const currentState = sessionStorage.getItem(varName);
  // if (currentState === null) return false;
  // return JSON.parse(currentState);

  /* Updated 3 here */
  const val = currentState === null ? false : JSON.parse(currentState);
  isLoading.value = val;
  return val;
}

function setLoadingState(state: boolean): void {
  const settingState = state ? JSON.stringify(state) : 'false';
  sessionStorage.setItem(varName, settingState);

  isLoading.value = state; // added 2
}

/**
 *
 * @return {
 * withLoading() : toggle global loading state depending on callback - duration
 * setIsLoading() : toggle global loading state
 * getLoadingState : get current loading state
 * }
 * @usage: const { setIsLoading, getLoadingState, withLoading } = useLoading()
 * !:: can be used anywhere cause state is being handled in the current Session storage
 */

export const useLoading = () => {
  return {
    isLoading, // added 2
    setIsLoading: (state: boolean, delay = 0) => {
      if (delay) {
        setLoadingState(true);
        setTimeout(() => {
          setLoadingState(false);
        }, delay);
      } else {
        setLoadingState(state);
      }
    },
    getLoadingState: () => {
      const isLoading: boolean = fetchGlobalLoadingState();
      return isLoading;
    },

    withLoading: async (callBack: () => void) => {
      try {
        setLoadingState(true);
        await callBack();
        setLoadingState(false);
      } catch (error) {
        setLoadingState(false);
        console.error(error);
      }
    },
  };
};
